module.exports = [
  {
    title: "Dashboard",
    url: "/",
    section: "Overview",
    icon: "LuLayoutDashboard",
    accessRoles: [0],
  },
  {
    title: "Add User",
    url: "/add-user",
    section: "Users",
    icon: "CiViewList",
    accessRoles: [1, 2],
  },
  {
    title: "Users List",
    url: "/users-list",
    section: "Users",
    icon: "CiViewList",
    accessRoles: [1, 2],
  },
  {
    title: "Manage KYC",
    url: "/manage-kyc",
    section: "Users",
    icon: "MdOutlinePermContactCalendar",
    accessRoles: [1, 2],
  },
  {
    title: "Add White Labels",
    url: "/add-white-labels",
    section: "White Labels",
    icon: "AiOutlineUsergroupAdd",
    accessRoles: [1],
  },
  {
    title: "White Labels List",
    url: "/get-white-labels",
    section: "White Labels",
    icon: "PiUserList",
    accessRoles: [1],
  },
  {
    title: "Deposits",
    url: "/deposits",
    section: "Finance",
    icon: "IoLogInOutline",
    accessRoles: [1, 2],
  },
  {
    title: "Withdrawals",
    url: "/withdrawals",
    section: "Finance",
    icon: "PiHandWithdraw",
    accessRoles: [1, 2],
  },
  {
    title: "Add Banking/crypto",
    url: "/banking",
    section: "Finance",
    icon: "PiHandWithdraw",
    accessRoles: [1],
  },
  {
    title: "All Transactions",
    url: "/all-transactions",
    section: "Finance",
    icon: "GrTransaction",
    accessRoles: [1, 2],
  },
  {
    title: "Deleted Users",
    url: "/deletedusersList",
    section: "Users",
    icon: "RiDeleteBin3Line",
    accessRoles: [1, 2],
  },
  {
    title: "All Trades",
    url: "/all-trades",
    section: "Trading",
    icon: "BsGraphUp",
    accessRoles: [1, 2],
  },
  {
    title: "Currency Pairs",
    url: "/currency-pairs",
    section: "Trading",
    icon: "FaExchangeAlt",
    accessRoles: [1, 2],
  },
  {
    title: "Corporate KYC",
    url: "/corporate-kyc",
    section: "Users",
    icon: "MdOutlinePermContactCalendar",
    accessRoles: [1, 2],
    groupName: "MoneyplantFX"
  },
  {
    title: "Corporate Users",
    url: "/corporate-users",
    section: "Users",
    icon: "MdOutlinePermContactCalendar",
    accessRoles: [1, 2],
    groupName: "MoneyplantFX"
  },
];
